import { SET_FOOTER_CONFIG } from './_types';

export const setFooterConfig = footerConfig => ({
  type: SET_FOOTER_CONFIG,
  payload: footerConfig,
});
